document.addEventListener('DOMContentLoaded', function () {
  const menuItem = document.querySelector('li.header__menu_li a[href*="career"]');
  if (!menuItem) return;

  var locale = document.documentElement.getAttribute('lang');
  var defaultLang = 'cs';
  if (menuItem && locale !== defaultLang) {
    menuItem.style.display = 'none';
  }

  

  const popup = document.createElement('div');
  popup.className = 'career-popup';

  const careers = [
    { title: 'Obchodní zástupce', location: 'Praha, CZ', description: 'Budování a udržování vztahů s klienty.' },
    // { title: 'Marketing Specialist', location: 'Remote / EU', description: 'Plan and execute marketing campaigns.' }
  ];

  popup.innerHTML = `<div class="career-announcement">
      <a href="/pages/career"><h3 class="career-heading">🚀 Máte vlastní klientskou bázi v B2B?</h3></a>
      <p>Hledáme obchodní partnery <b>IČO (OSVČ)</b>, kteří chtějí rozšířit své portfolio 
      o elektroinstalační techniku s reálným prodejním potenciálem.</p>

      <ul class="career-points">
        <li>💰 FIX + Provizní spolupráce bez stropu</li>
        <li>🤝 Partnerství, ne zaměstnání</li>
        <li>📈 Produkty, které se prodávají</li>
      </ul>

      <p>Zastupujete značku <b>Principal Elektrik</b> ve svém regionu, 
      my dodáme produkt, zázemí a podporu.</p>
    </div>

    <a href="/pages/career" class="career-view-all">Zobrazit nabídku</a>
  `;


  const translations = {
    cs: 'Zobrazit všechny nabídky',
    en: 'View All Offers',
    de: 'Alle Angebote anzeigen'
  };

  const lang = document.documentElement.lang?.substring(0, 2) || 'en';

//   const viewAllBtn = document.createElement('a');
//   viewAllBtn.className = 'career-view-all';
//   viewAllBtn.textContent = translations[lang] || translations.en; 
//   viewAllBtn.href = '/pages/career';
//   popup.appendChild(viewAllBtn);

  const li = menuItem.closest('li');
  li.style.position = 'relative';
  li.appendChild(popup);

  li.addEventListener('mouseenter', () => popup.classList.add('visible'));
  li.addEventListener('mouseleave', () => popup.classList.remove('visible'));

  menuItem.addEventListener('click', (e) => {
    e.stopPropagation();
    popup.classList.toggle('visible');
  });

  document.addEventListener('click', (e) => {
    if (!li.contains(e.target)) popup.classList.remove('visible');
  });
});